import { ConsignmentModel } from '@shared/app/scripts/classes/consignment-model';
import { Injectable } from 'angular-ts-decorators';
import { SpynlBase } from '@shared/app/scripts/services/spynl-base';

import { Domain } from './domain';
import type { IConfig } from './config';
import type { IStandardErrorParser } from './standard-error-parser';

/**
 * Simple service to take care of communicating with new /consignments/add endpoint
 */
@Injectable('consignment')
export class Consignment extends SpynlBase<ConsignmentModel> {
  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';
    super(
      $http,
      $q,
      sentry,
      domain,
      config,
      standardErrorParser,
      ConsignmentModel,
    );
    this.location = '/consignments';
  }

  /**
   * @returns {promise}
   * Resolve with response on success, otherwise reject with the error
   */
  startNew(): ng.IPromise<{}> {
    return this.$http
      .post(
        this.domain.getSpynl() + '/consignments/start-new',
        {},
        {
          // done on config level for v7; setting for v6
          withCredentials: true,
        },
      )
      .then((response: any) => response.data.data);
  }
}
